import { PrimaryFeatureFrame } from "../PrimaryFeatureFrame"

export function Explore() {
    return (
        <PrimaryFeatureFrame>
            <div className="flex h-full flex-col overflow-hidden rounded-lg">
                <div className="flex h-8 flex-col justify-center bg-primary-600/75 text-xs font-semibold text-white">
                    <span className="ml-2">Product market fit report - March 2023</span>
                </div>
                <div className="flex w-full grow flex-row">
                    <div className="w-40 border-r">
                        <div className="h-12 w-full border-b"></div>
                        <div className="h-12 w-full border-b"></div>
                        <div className="h-12 w-full border-b bg-primary-600/20 shadow-inner"></div>
                        <div className="h-12 w-full border-b"></div>
                        <div className="h-12 w-full border-b"></div>
                        <div className="h-12 w-full border-b"></div>
                        <div className="h-12 w-full border-b"></div>
                        <div className="h-12 w-full border-b"></div>
                        <div className="h-12 w-full border-b"></div>
                        <div className="h-12 w-full border-b"></div>
                    </div>
                    <div className="grow">
                        <div className="p-4">
                            <h2 className="mb-4 text-sm font-semibold">
                                What are the most positive things about the research world in 2023?
                            </h2>
                            <div className="grid w-full grid-cols-2">
                                <div className="flex flex-col justify-around">
                                    <div className="mr-4 flex h-10 flex-col justify-center text-right">
                                        <span>Innovation with AI and ML</span>
                                    </div>
                                    <div className="mr-4 flex h-10 flex-col justify-center text-right">
                                        <span>Increased understanding of customer behavior</span>
                                    </div>
                                    <div className="mr-4 flex h-10 flex-col justify-center text-right">
                                        <span>Renewed focus on quality</span>
                                    </div>
                                    <div className="mr-4 flex h-10 flex-col justify-center text-right">
                                        <span>Emergence of new tools</span>
                                    </div>
                                    <div className="mr-4 flex h-10 flex-col justify-center text-right">
                                        <span>Potential growth of industry</span>
                                    </div>
                                </div>
                                <div className="flex h-[300px] flex-col justify-around border border-gray-300">
                                    <div className="h-10 w-[90%] bg-teal-600"></div>
                                    <div className="h-10 w-[71%] bg-teal-600"></div>
                                    <div className="h-10 w-[52%] bg-teal-600"></div>
                                    <div className="h-10 w-[29%] bg-teal-600"></div>
                                    <div className="h-10 w-[14%] bg-teal-600"></div>
                                </div>
                            </div>
                            <div>
                                <h3 className="mt-4 text-xs font-semibold">Examples</h3>
                                <h4 className="mt-2 text-xs">Innovation with AI and ML</h4>
                                <ul className="mt-2 list-inside list-disc space-y-2 text-xs text-gray-600">
                                    <li>AI for open ended coding and survey design</li>
                                    <li>
                                        The use of AI to take out the grunt work especially for the junior researchers
                                    </li>
                                    <li>AI, ML and advanced analytics could put insights back on centre stage</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </PrimaryFeatureFrame>
    )
}
